import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["data-information-box-type"]
const _hoisted_2 = {
  key: 0,
  class: "w-6 h-6 flex-col justify-center content-center gap-2.5 flex-shrink-0"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "flex content-center" }
const _hoisted_5 = { class: "flex-col flex-grow content-center items-end" }
const _hoisted_6 = { class: "flex flex-col gap-4" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-row mt-4"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_10 = { class: "list-none" }
const _hoisted_11 = { class: "m-auto m-1 md:inline-block" }
const _hoisted_12 = ["href", "innerHTML"]
const _hoisted_13 = { key: 2 }

import { ref } from 'vue';
import { IInformationBox, LinkTypes } from '@/interfaces/forms/information-box.interface';
import { computed } from 'vue';
import ShowHideButton from '../ShowHideButton/ShowHideButton.vue';

export interface INotification extends IInformationBox {
  showMoreText: string;
  showLessText: string;
  fullWidth?: boolean;
  openByDefault?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Notification',
  props: {
    showMoreText: {},
    showLessText: {},
    fullWidth: { type: Boolean },
    openByDefault: { type: Boolean },
    type: {},
    title: {},
    description: {},
    links: {},
    hideIcon: { type: Boolean },
    isCircle: { type: Boolean },
    useButtonSlot: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const expanded = ref<boolean>(props.openByDefault);

const iconMap = {
  info: require('@/assets/icons/info-information.svg'),
  warning: require('@/assets/icons/info-warning.svg'),
  error: require('@/assets/icons/info-error.svg'),
  success: require('@/assets/icons/info-success.svg'),
  marketing: require('@/assets/icons/info-marketing.svg'),
};

const backgroundColorMap = {
  info: 'bg-racq-info-light-blue',
  warning: 'bg-racq-info-light-yellow',
  error: 'bg-racq-info-light-red',
  success: 'bg-racq-info-light-green',
  marketing: 'bg-racq-light-purple',
};

function getButtonClasses(link: any) {
  if (!link) return '';

  switch (link.type) {
    case LinkTypes.BUTTON_PRIMARY:
      return 'btn btn-primary';

    case LinkTypes.BUTTON_SECONDARY:
      return 'btn btn-secondary';
  }
}

const icon = computed(() => iconMap[props.type]);
const backgroundColor = computed(() => backgroundColorMap[props.type]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['w-full px-4 md:px-6 py-5 rounded', backgroundColor.value, _ctx.fullWidth ? 'w-full' : 'max-w-[784px]'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['flex w-full gap-3 ']),
      "data-information-box-type": _ctx.type
    }, [
      (!!icon.value && !_ctx.hideIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: icon.value,
              alt: `${_ctx.type} icon`,
              class: "w-4 h-4"
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: "cursor-pointer text-racq-dark-grey text-base-bold",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
        }, _toDisplayString(_ctx.title), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(ShowHideButton, {
          class: "float-right !mt-0 md:hidden",
          showMore: expanded.value,
          showMoreLabel: "",
          showLessLabel: "",
          appendClass: "relative",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (expanded.value = !expanded.value))
        }, null, 8, ["showMore"]),
        _createVNode(ShowHideButton, {
          class: "float-right !mt-0 hidden md:flex",
          showMore: expanded.value,
          showMoreLabel: _ctx.showMoreText,
          showLessLabel: _ctx.showLessText,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (expanded.value = !expanded.value))
        }, null, 8, ["showMore", "showMoreLabel", "showLessLabel"])
      ])
    ], 8, _hoisted_1),
    _createElementVNode("div", _hoisted_6, [
      (!_ctx.$slots.infoBoxContent && _ctx.description && expanded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "text-dark-grey-text text-m",
              innerHTML: _ctx.description
            }, null, 8, _hoisted_8)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.$slots.infoBoxContent && _ctx.links && expanded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("ul", _hoisted_10, [
              _createElementVNode("li", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: index,
                    href: link.url,
                    class: _normalizeClass(["text-m mr-5 mt-5", getButtonClasses(link)]),
                    innerHTML: link.title
                  }, null, 10, _hoisted_12))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.buttons)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_ctx.$slots.buttons && expanded.value)
              ? _renderSlot(_ctx.$slots, "buttons", { key: 0 }, () => [
                  _cache[3] || (_cache[3] = _createTextVNode(" [Named slot for info box content (buttons)]"))
                ])
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})